/**
 *  Module tenantDataConfigServiceModule
 *
 * Description 租户共享数据服务
 *  Author Qian.qianchen 2019-07-16
 */

'use strict';

angular.module('tenantDataConfigServiceModule', ['shareDataEditModule'])
    .factory('tenantDataConfigService', ["$modal", "$q", function($modal, $q) {
        return {
            /**
             * [editShareData description] 成品共享数据配置
             * @param  {[type]} tenantId  [description] 租户id
             * @param  {[type]} productId [description] 产品ID
             * @return {[type]}           [description]
             */
            editShareData: function(tenantId, product) {
                let defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: "./manageConfig/tenantManageMent/allTenantManage/tenantDataConfig/service/shareDataEdit/shareDataEdit_tpl.html",
                    windowClass: 'share_data_edit_container',
                    backdrop: false,
                    controller: "shareDataEditCtrl",
                    resolve: {
                        tenantId: function() {
                            return tenantId;
                        },
                        product: function() {
                            return product;
                        }
                    }
                });
                //关闭弹窗
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                }, function() {
                    defer.reject("cancel");
                });
                return defer.promise;
            }
        }
    }]);